module.exports = __webpack_public_path__ + "img/619.01420672.jpg";